// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wishlist-button {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.2s;
  background-color: #9ca3af;

  &:hover {
    background-color: #f87171;
    transform: scale(1.25);
  }
}

.wishlist-button.is-selected {
  background-color: #dc2626;
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/WishListButton.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iDAAiD;EACjD,yBAAyB;;EAEzB;IACE,yBAAyB;IACzB,sBAAsB;EACxB;AACF;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".wishlist-button {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  border-radius: 9999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.2s, transform 0.2s;\n  background-color: #9ca3af;\n\n  &:hover {\n    background-color: #f87171;\n    transform: scale(1.25);\n  }\n}\n\n.wishlist-button.is-selected {\n  background-color: #dc2626;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
